import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, of } from "rxjs";
import { share } from "rxjs/operators";
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: "root"
})
export class ApiClientService {
    private readonly http = inject(HttpClient);
    private readonly cache = new Map();
    static readonly JsonHeader: HttpHeaders = new HttpHeaders({ "content-type": "application/json" });

    get<T>(route: string, legacy = false, params: any = null): Observable<T> {
        const url = this.getUrl(route, legacy);
        const cleanedParams: any = params
            ? Object.fromEntries(Object.entries(params).filter(([, v]) => v != null))
            : undefined;
        return this.http.get<T>(url, { params: cleanedParams }).pipe(share());
    }

    getRaw(route: string, legacy = false, options: any = null): Observable<any> {
        const url = this.getUrl(route, legacy);
        return this.http.get(url, options).pipe(share());
    }

    postRaw(route: string, body: any, legacy = false, options: any = null): Observable<any> {
        const url = this.getUrl(route, legacy);
        return this.http.post(url, body, options).pipe(share());
    }

    post<TRequest, TResponse>(route: string, body: TRequest, legacy = false, params: any = null, headers: any = null): Observable<TResponse> {
        const url = this.getUrl(route, legacy);
        return this.http.post<TResponse>(url, body, {
            headers: headers,
            params: params
        }).pipe(share());
    }

    delete(route: string, legacy = false, params: any = null): Observable<any> {
        const url = this.getUrl(route, legacy);
        return this.http.delete(url, { params: params }).pipe(share());
    }

    put<TRequest, TResponse>(route: string, body: TRequest, legacy = false, params: any = null): Observable<TResponse> {
        const url = this.getUrl(route, legacy);
        return this.http.put<TResponse>(url, body, { params: params }).pipe(share());
    }

    getCached<T>(route: string, legacy = false, params: any = null, reset = false): Observable<T> {
        const url = this.getUrl(route, legacy);
        const cacheObj = this.cache.get(url);
        if (cacheObj && !reset) {
            return of(cacheObj);
        } else {
            const obj = this.get<T>(route, legacy, params);
            obj.subscribe(res => this.cache.set(url, res));
            return obj;
        }
    }

    private getUrl(route: string, legacy = false) {
        const base = legacy ? environment.api : environment.apiV2;
        const cleanRoute = route.startsWith("/") ? route.slice(1) : route;
        return `${base}/${cleanRoute}`;
    }
}
